// Mini parser RFC4180-ish suficiente para CSVs exportados de Excel/Sheets/Numbers.
// Soporta: separador ',' o ';' (auto), comillas dobles "" para escape, valores
// con saltos de línea entre comillas, BOM UTF-8. No depende de librerías externas.

const stripBom = (s) => (s.charCodeAt(0) === 0xfeff ? s.slice(1) : s);

const detectDelimiter = (firstLine) => {
  const semi = (firstLine.match(/;/g) || []).length;
  const comma = (firstLine.match(/,/g) || []).length;
  return semi > comma ? ';' : ',';
};

// Tokeniza una línea respetando comillas. Devuelve array de strings (sin trim).
const splitRow = (row, delim) => {
  const out = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < row.length; i++) {
    const c = row[i];
    if (inQuotes) {
      if (c === '"' && row[i + 1] === '"') { cur += '"'; i++; }
      else if (c === '"') inQuotes = false;
      else cur += c;
    } else {
      if (c === '"') inQuotes = true;
      else if (c === delim) { out.push(cur); cur = ''; }
      else cur += c;
    }
  }
  out.push(cur);
  return out;
};

// Junta líneas físicas en lógicas, respetando comillas que abarquen \n.
const joinLogicalRows = (text) => {
  const rows = [];
  let buf = '';
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (c === '"') { inQuotes = !inQuotes; buf += c; continue; }
    if ((c === '\n' || c === '\r') && !inQuotes) {
      if (c === '\r' && text[i + 1] === '\n') i++;
      if (buf.length > 0) { rows.push(buf); buf = ''; }
      continue;
    }
    buf += c;
  }
  if (buf.length > 0) rows.push(buf);
  return rows;
};

// Parsea CSV a { headers: string[], rows: Array<Record<string,string>> }.
// Las claves del objeto fila son los headers en lower-case y trimmed para
// tolerar variaciones ("Name" vs " name ").
export function parseCSV(text) {
  const clean = stripBom(String(text || ''));
  const logical = joinLogicalRows(clean);
  if (!logical.length) return { headers: [], rows: [] };
  const delim = detectDelimiter(logical[0]);
  const rawHeaders = splitRow(logical[0], delim).map((h) => h.trim());
  const headers = rawHeaders.map((h) => h.toLowerCase());
  const rows = logical.slice(1)
    .filter((line) => line.trim() !== '')
    .map((line) => {
      const cells = splitRow(line, delim);
      const obj = {};
      headers.forEach((h, idx) => { obj[h] = (cells[idx] ?? '').trim(); });
      return obj;
    });
  return { headers: rawHeaders, rows };
}

// Slug simple para fallback de matching por nombre. Quita acentos, espacios,
// puntuación y baja a lower-case. "1970 Chevy Nova" → "1970chevynova".
export function slugify(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}
